import { render, staticRenderFns } from "./NoticeForAdd.vue?vue&type=template&id=64c544b9&scoped=true"
import script from "./NoticeForAdd.vue?vue&type=script&lang=js"
export * from "./NoticeForAdd.vue?vue&type=script&lang=js"
import style0 from "./NoticeForAdd.vue?vue&type=style&index=0&id=64c544b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c544b9",
  null
  
)

export default component.exports